const MENU_CONTENT_CLASSNAME =
  'w-[19rem] min-w-[19rem] max-w-none p-0 rounded-[1.2rem] border border-stroke bg-background/94 backdrop-blur-[0.8rem] shadow-(--shadow-dropdown)';

const MENU_VIEWPORT_CLASSNAME =
  'flex flex-col gap-[0.8rem] w-full min-w-0 max-w-full p-[0.4rem]';

const MENU_ITEM_CLASSNAME =
  'h-[3.6rem] w-full rounded-[0.8rem] px-[1.2rem] py-[0.8rem] cursor-pointer';

const MENU_ITEM_CONTENT_CLASSNAME = 'gap-[0.8rem]';

const MENU_ITEM_ICON_CLASSNAME = 'size-[1.6rem]';

const MENU_ITEM_LABEL_CLASSNAME = 'medium5';

const SUBMENU_CLASSNAME =
  'flex flex-col gap-[0.8rem] rounded-[1.2rem] border border-stroke bg-background/94 backdrop-blur-[0.8rem] p-[0.4rem] shadow-(--shadow-dropdown)';

export {
  MENU_CONTENT_CLASSNAME,
  MENU_VIEWPORT_CLASSNAME,
  MENU_ITEM_CLASSNAME,
  MENU_ITEM_CONTENT_CLASSNAME,
  MENU_ITEM_ICON_CLASSNAME,
  MENU_ITEM_LABEL_CLASSNAME,
  SUBMENU_CLASSNAME,
};
